var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { ChildComponent } from '../../../../pages/modules/child-component';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
import { computedFrom } from 'aurelia-binding';
var LotteryBrandSettings = /** @class */ (function (_super) {
    __extends(LotteryBrandSettings, _super);
    function LotteryBrandSettings(notificationService, i18N) {
        return _super.call(this, notificationService, i18N) || this;
    }
    Object.defineProperty(LotteryBrandSettings.prototype, "isPromotion", {
        get: function () {
            return this._isPromotion;
        },
        set: function (value) {
            this._isPromotion = value;
            this.item.brandLotteries[0].isPromotion = value;
        },
        enumerable: false,
        configurable: true
    });
    LotteryBrandSettings.prototype.attached = function () {
        this._isPromotion = this.item.brandLotteries[0].isPromotion;
    };
    LotteryBrandSettings.prototype.remove = function (x) {
        var index = this.item.brandLotteries[0].brandLotteryRestrictedCountries.indexOf(x);
        if (index >= 0)
            this.item.brandLotteries[0].brandLotteryRestrictedCountries.splice(index, 1);
    };
    LotteryBrandSettings.prototype.add = function () {
        this.item.brandLotteries[0].brandLotteryRestrictedCountries.push({
            brandLotteryRestrictedCountryId: 0,
            brandLotteryId: 0,
            countryId: 0
        });
    };
    __decorate([
        computedFrom("_isPromotion"),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], LotteryBrandSettings.prototype, "isPromotion", null);
    LotteryBrandSettings = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N])
    ], LotteryBrandSettings);
    return LotteryBrandSettings;
}(ChildComponent));
export { LotteryBrandSettings };
